<template>
  <div class="search-input">
    <input v-model="searchPhrase" :placeholder="searchPlaceholder" class="search">
  </div>
</template>

<script>
import content from '@/translations/content'

export default {
  name: 'Search',
  mixins: [ content ],
  data() {
    return {
      searchPhrase: ''
    }
  },
  watch: {
    searchPhrase: function () {
      this.$emit('input', this.searchPhrase)
    }
  }
}
</script>